<script>
    import app from '../../stores/app';
    import AppIcon from "../icons/AppIcon.svelte";
    import Icon from "../Icon.svelte";
    import {clickOutside} from "../../lib/clickOutside";

    export let users = [];

    let dropDownVisible = false;

    const toggleDropdown = () => {
        dropDownVisible = !dropDownVisible;
    }

    const onSelectUser = obj => {
        users = [...users, obj];
        dropDownVisible = false;
    }

    const removeUser = item => {
        users = users.filter(x => x.id != item.id);
        dropDownVisible = false;
    }

    const inUsers = id => {
        return users.some(x => x.id == id);
    }
</script>

<div>
    {#if users.length > 0}
        {#each users as item}
            <div class="assigned-user">
                {item.name}
                <button class="btn remove" on:click={() => removeUser(item)}><AppIcon icon="x"/></button>
            </div>
        {/each}
    {:else}
        <div class="alert alert-warning mb-0">
            Δεν έχει επιλεχτεί χρήστης
        </div>
    {/if}
</div>

{#if users.length != $app.users.length}
    <div class="dropdown-container">
        <button class="btn btn-link btn-content-flex ps-1" on:click="{ toggleDropdown }">
            <Icon name="plus-circle" strokeWidth="2" cssClass="pe-1"/>
            προσθήκη
        </button>
        {#if dropDownVisible}
            <div class="dropdown w-full" use:clickOutside on:click_outside="{ () => dropDownVisible = false }">
                {#each $app.users as item}
                    {#if !inUsers(item.id)}
                        <button class="dropdown-item" on:click="{ () => onSelectUser(item) }">
                            {item.name}
                        </button>
                    {/if}
                {/each}
            </div>
        {/if}
    </div>
{/if}

<style>
    .assigned-user {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #e4eaee;
        border-radius: 2px;
        padding: 0 0 0 10px;
        margin: 1px 0;
    }

    .assigned-user:first-child {
        margin-top: 0;
    }

    .assigned-user .remove {
        padding: 9px 10px;
    }

    .assigned-user .remove:hover {
        color: #fff;
        background: #ff0000;
    }
</style>